import { useEffect } from 'react';

import {
  useAgentActions,
  useAgentState,
} from '#/features/terminal/agent-context';
import { useBlockTerminalPendingStore } from '#/features/terminal/pending-message-store';

/**
 * Drains a queued message (e.g. from "Analyze in Terminal") once the
 * agent reaches the `authenticated` status. Pending messages are
 * pushed by other surfaces via the pending-message store — this
 * component is the only consumer.
 *
 * Renders nothing.
 */
export default function PendingMessageDrain() {
  const { status } = useAgentState();
  const { sendMessage } = useAgentActions();
  const pending = useBlockTerminalPendingStore((s) => s.pending);
  const consumePending = useBlockTerminalPendingStore((s) => s.consumePending);

  useEffect(() => {
    if (pending == null) return;
    if (status !== 'authenticated') return;
    const drained = consumePending();
    if (drained != null) sendMessage(drained.text);
  }, [pending, status, consumePending, sendMessage]);

  return null;
}
